"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.array.find");
require("core-js/modules/es6.number.constructor");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _methods; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'TaskAdd',
  emits: ['saved'],
  props: {
    taskId: {
      type: [Number],
      default: null
    }
  },
  watch: {
    taskId: {
      immediate: true,
      handler: function handler(id) {
        this.loadRuleOptions();
        if (id) {
          this.fetchTaskDetail(id);
        } else {
          this.resetForm();
        }
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      // 控制 v-loading 显示隐藏
      ruleOptions: [],
      selectedRuleText: '',
      // 用于展示的说明文本
      cycleExplain: {
        '1': '该任务将每年触发一次。',
        '2': '该任务将每季度（3个月）触发一次。',
        '3': '该任务将每月触发一次。',
        '3.2': '该任务将每周触发一次。',
        '4': '该任务将每日触发一次，不支持隔日奖励发放。'
      },
      form: {
        title: '',
        taskType: '',
        cycleDays: '',
        rewardType: '',
        rewardValue: '',
        status: 1,
        icon: '',
        sortOrder: 0,
        description: '',
        ruleCode: '',
        triggerCondition: '',
        rangeType: 0,
        typeIdList: [],
        typeIdList2: [],
        grant: ''
      },
      ruleForm: {
        orderCount: 0,
        consumeDays: 0,
        amount: 0,
        consumeType: 1,
        rechargeAmt: 0,
        useBalance: 0,
        rangeType: 0,
        typeIdCount: 1,
        countType: 0,
        commentCount: 1
      },
      productOptions: [],
      categoryOptions: [],
      loadingProducts: false,
      loadingCategories: false,
      rules: {
        title: [{
          required: true,
          message: '请输入任务标题',
          trigger: 'blur'
        }],
        taskType: [{
          required: true,
          message: '请选择任务类型',
          trigger: 'change'
        }],
        rewardType: [{
          required: true,
          message: '请选择奖励类型',
          trigger: 'change'
        }],
        ruleCode: [{
          required: true,
          message: '请选择规则',
          trigger: 'change'
        }],
        rewardValue: [{
          required: true,
          message: '请输入奖励内容',
          trigger: 'blur'
        }],
        status: [{
          required: true,
          message: '请选择状态',
          trigger: 'change'
        }],
        paidAmount: [{
          required: true,
          message: '请输入实付金额',
          trigger: 'blur'
        }, {
          type: 'number',
          min: 0,
          message: '金额必须为非负数字',
          trigger: 'blur'
        }],
        cycleDays: [{
          required: function required() {
            return this.form.taskType === 'cycle';
          },
          message: '请选择周期',
          trigger: 'change'
        }]
      },
      couponOptions: [],
      couponLoading: false,
      ruleOptions2: [],
      productQuery: '',
      categoryQuery: ''
    };
  },
  mounted: function mounted() {},
  methods: (_methods = {
    // 切换范围时清空列表
    onRangeTypeChange: function onRangeTypeChange(val) {
      if (val === 0) {
        this.productOptions = [];
        this.productQuery = '';
      } else {
        this.categoryOptions = [];
        this.categoryQuery = '';
      }
    },
    // 查询商品
    searchProducts: function searchProducts() {
      var _this = this;
      this.loadingProducts = true;
      var params = {
        page: 1,
        limit: 50,
        keywords: this.productQuery || ''
      };
      (0, _taskConfig.fetchProducts)(params).then(function (res) {
        _this.productOptions = res.records || [];
      }).finally(function () {
        _this.loadingProducts = false;
      });
    },
    // 查询分类
    searchCategories: function searchCategories() {
      var _this2 = this;
      this.loadingCategories = true;
      var params = {
        page: 1,
        limit: 99,
        keywords: this.categoryQuery || ''
      };
      (0, _taskConfig.fetchCategories)(params).then(function (res) {
        _this2.categoryOptions = res.records || [];
      }).finally(function () {
        _this2.loadingCategories = false;
      });
    }
  }, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "onRangeTypeChange", function onRangeTypeChange(val) {
    // 可选：加载对应数据（如果需要）
    if (val === 0) {
      // 按商品：加载商品
      this.searchProducts();
    } else {
      // 按分类：加载分类
      this.searchCategories();
    }
  }), "fetchProducts", function fetchProducts(query) {
    var _this3 = this;
    this.loadingProducts = true;
    var params = {
      page: 1,
      limit: 99,
      keywords: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
    };
    (0, _taskConfig.fetchProducts)(params).then(function (res) {
      _this3.productOptions = res.records || [];
    }).finally(function () {
      _this3.loadingProducts = false;
    });
  }), "fetchCategories", function fetchCategories(query) {
    var _this4 = this;
    this.loadingCategories = true;
    var params = {
      page: 1,
      limit: 99,
      keywords: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
    };
    (0, _taskConfig.fetchCategories)(params).then(function (res) {
      _this4.categoryOptions = res.records || [];
    }).finally(function () {
      _this4.loadingCategories = false;
    });
  }), "loadRuleOptions", function loadRuleOptions() {
    var _this5 = this;
    (0, _taskConfig.fetchAllTaskRules)().then(function (res) {
      _this5.ruleOptions = res || [];
      if (!_this5.form.taskType) return _this5.ruleOptions;
      return _this5.ruleOptions.filter(function (item) {
        return item.ruleType === _this5.form.taskType;
      });
    });
  }), "handleRuleChange", function handleRuleChange(val) {
    var _this6 = this;
    if (val === 'd') {
      this.$message.error('暂不支持！');
      setTimeout(function () {
        _this6.form.ruleCode = '';
      }, 1000); // 1000 毫秒 = 1 秒
      return;
    }
    if (val === 'e') {
      this.onRangeTypeChange(0); //默认选中商品
    }
    if (this.form.triggerCondition) {
      this.ruleForm = JSON.parse(this.form.triggerCondition);
    } else {
      this.ruleForm = {
        orderCount: 0,
        consumeDays: 0,
        amount: 0,
        consumeType: 1,
        rechargeAmt: 0,
        useBalance: 0,
        typeIdCount: 1,
        countType: 0,
        rangeType: 0,
        commentCount: 1
      };
    }
    var selected = this.ruleOptions.find(function (item) {
      return item.ruleCode === val;
    });
    this.selectedRuleText = selected ? selected.ruleText : '';
    this.form.grant = selected.grant;
    if (this.form.cycleDays == 4) {
      //按日不支持隔天领
      this.form.grant = 0;
    }
  }), "fetchTaskDetail", function fetchTaskDetail(id) {
    var _this7 = this;
    (0, _taskConfig.getTaskDetail)(id).then(function (res) {
      _this7.form = res; // 假设返回的数据结构是 { data: {...} }
      console.log(" res", res);
      // this.form.typeIdList = (res.typeIdList || []).map(id => parseInt(id, 10));
      _this7.ruleForm = JSON.parse(_this7.form.triggerCondition);
      _this7.form.rangeType = _this7.ruleForm.rangeType;
      // this.onRangeTypeChange(this.form.rangeType);//默认选中商品
      if (_this7.ruleForm.rangeType == 0) {
        _this7.form.typeIdList = res.typeIdListResp || [];
        console.log(" typeIdList", _this7.form.typeIdList.size);
      } else {
        _this7.form.typeIdList2 = res.typeIdListResp || [];
        console.log(" typeIdList2", _this7.form.typeIdList2.size);
      }
      if (_this7.form.rewardType == 'coupon') {
        (0, _taskConfig.fetchExBonusType)(_this7.form.rewardValue).then(function (response) {
          _this7.couponOptions = [response.data];
          _this7.form.rewardValue = response.data.typeId;
          _this7.ruleOptions2 = _this7.ruleOptions.filter(function (item) {
            return item.ruleType === _this7.form.taskType;
          });
          _this7.handleRuleChange(_this7.form.ruleCode);
        }).catch(function (error) {
          console.error('获取失败:', error);
        });
      } else {
        _this7.ruleOptions2 = _this7.ruleOptions.filter(function (item) {
          return item.ruleType === _this7.form.taskType;
        });
        _this7.handleRuleChange(_this7.form.ruleCode);
      }
    }).catch(function (error) {
      _this7.$message.error('任务详情加载失败');
    });
  }), "taskTypeChange", function taskTypeChange() {
    // 如果周期为“按日”
    if (this.form.cycleDays == 4) {
      this.form.grant = 0;
    } else {
      this.form.grant = 1; // 隔天
    }
  }), "handleTaskTypeChange", function handleTaskTypeChange() {
    var _this8 = this;
    this.ruleOptions2 = [];
    this.form.ruleCode = '';
    this.form.grant = '';
    if (this.form.triggerCondition) {
      this.ruleForm = JSON.parse(this.form.triggerCondition);
    } else {
      this.ruleForm = {
        orderCount: 0,
        consumeDays: 0,
        commentCount: 1,
        amount: 0,
        consumeType: 1,
        rechargeAmt: 0,
        useBalance: 0,
        typeIdCount: 1,
        countType: 0,
        rangeType: 0
      };
    }
    if (this.form.taskType !== 'cycle') {
      this.form.cycleDays = '';
      this.form.grant = 0; // 实时
    }
    this.ruleOptions2 = this.ruleOptions.filter(function (item) {
      return item.ruleType === _this8.form.taskType;
    });
  }), "handleRewardTypeChange", function handleRewardTypeChange() {
    this.form.rewardValue = '';
    if (this.form.rewardType == 'coupon') {
      this.fetchCoupons("");
    }
  }), "fetchCoupons", function fetchCoupons(query) {
    var _this9 = this;
    this.couponLoading = true;
    var params = {
      page: 1,
      limit: 99,
      typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
    };
    (0, _taskConfig.getBonusTypes)(params).then(function (res) {
      _this9.couponOptions = res.records || [];
    }).finally(function () {
      _this9.couponLoading = false;
    });
  }), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_methods, "resetForm", function resetForm() {
    var _this0 = this;
    this.$nextTick(function () {
      _this0.form = {
        title: '',
        taskType: '',
        cycleDays: '',
        rewardType: '',
        rewardValue: '',
        status: 1,
        icon: '',
        sortOrder: 0,
        description: '',
        ruleCode: '',
        triggerCondition: '',
        rangeType: 0,
        typeIdList: [],
        typeIdList2: [],
        grant: ''
      };
      _this0.ruleForm = {
        orderCount: 0,
        consumeDays: 0,
        commentCount: 1,
        amount: 0,
        consumeType: 1,
        rechargeAmt: 0,
        useBalance: 0,
        typeIdCount: 1,
        countType: 0,
        rangeType: 0
      };
    });
  }), "handleCustomUpload", function handleCustomUpload(_ref) {
    var _this1 = this;
    var file = _ref.file;
    var formData = new FormData();
    formData.append('file', file);
    (0, _taskConfig.uploadImg)(formData).then(function (res) {
      var url = res.data; // 按实际调整

      // 更新展示地址
      _this1.form.icon = url;
      console.log(_this1.form.icon);
      _this1.$message.success('上传成功');
    }).catch(function () {
      _this1.$message.error('上传失败');
    });
  }), "handleSubmit", function handleSubmit() {
    var _this10 = this;
    this.loading = true; // 开始加载
    this.$refs.formRef.validate(/*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(valid) {
        var _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (valid) {
                _context.next = 1;
                break;
              }
              _this10.loading = false; // 停止加载
              return _context.abrupt("return");
            case 1:
              if (!(_this10.form.taskType === 'cycle' && !_this10.form.cycleDays)) {
                _context.next = 2;
                break;
              }
              _this10.loading = false; // 停止加载
              _this10.$message.error('循环任务需要选择周期！');
              return _context.abrupt("return");
            case 2:
              if (!(_this10.form.ruleCode == 'c' && _this10.form.taskType === 'cycle')) {
                _context.next = 3;
                break;
              }
              if (!(_this10.ruleForm.orderCount <= 0 && _this10.ruleForm.consumeDays <= 0 && _this10.ruleForm.amount <= 0)) {
                _context.next = 3;
                break;
              }
              _this10.loading = false; // 停止加载
              _this10.$message.error('消费条件必须指定一项！');
              return _context.abrupt("return");
            case 3:
              _context.prev = 3;
              _this10.form.rangeType = _this10.ruleForm.rangeType;
              _this10.form.triggerCondition = JSON.stringify(_this10.ruleForm);
              console.log(_this10.form);
              if (!_this10.form.id) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return (0, _taskConfig.updateTask)(_this10.form);
            case 4:
              _this10.$message.success('任务修改成功');
              _this10.loading = false; // 停止加载
              _context.next = 7;
              break;
            case 5:
              _context.next = 6;
              return (0, _taskConfig.createTask)(_this10.form);
            case 6:
              _this10.$message.success('任务新增成功');
              _this10.loading = false; // 停止加载
            case 7:
              _this10.$emit('saved'); // 通知父组件刷新列表
              _this10.handleClose();
              _context.next = 9;
              break;
            case 8:
              _context.prev = 8;
              _t = _context["catch"](3);
              _this10.$message.error('提交失败，请稍后重试');
              _this10.loading = false; // 停止加载
            case 9:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[3, 8]]);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
  }), "handleClose", function handleClose() {
    this.$emit('update:visible', false);
  }))
};